<template>
    <div style="height: 100%">
        <div id="main">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="tipos-servicos vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t('work-flow-situacao-pedido') }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('vendas') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('work-flow-situacao-pedido') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button class="save-btn" type="button" tag="button"
                                @click="save">
                                {{ $t('salvar') }}
                            </button>
                        </div>
                    </div>

                    <div class="search-and-filter columns">
                        <div class="column is-4">
                            <vss-select
                                ref="perfilInput"
                                :title="$t('perfil')"
                                :value="perfilSelected ? perfilSelected.label : ''"
                                placeholder="selecione"
                                :options="perfisList"
                                @input="selectPerfil"
                            />
                        </div>
                        <div class="column is-4 complete-size">
                            <fSwitch 
                                :text="$t('somente-exibir-situacoes-que-sao-usadas-por-este-perfil')" 
                                :checked="isCheckFilterGrid" 
                                @change="handleCheckboxClick($event)"
                            />
                        </div>
                    </div>

                    <div class="registry-wrapper" v-if="perfilSelected">
                        <empty-table-message v-if="situacoes.length == 0" />
                        <div class="content-overflow" v-if="situacoes.length > 0">
                            <div class="flex-table">
                                <div class="flex-col has-text-centered">
                                    <!-- Orientação -->
                                    <div class="flex-cell flex-cell-info" v-if="situacoes.length == situacaoList.length">
                                    </div>
                                    <!-- Linhas -->
                                    <div class="flex-cell" v-if="situacoes.length == situacaoList.length" v-for="linha in situacoes">
                                        <div class="flex-cell-text">
                                            {{ linha.label }}
                                        </div>
                                    </div>
                                </div>
                                <!-- Colunas -->
                                <div class="flex-col has-text-centered" v-if="situacoes.length == situacaoList.length" v-for="coluna in situacoes">
                                    <div class="flex-cell">
                                        <div class="flex-cell-text">
                                            {{ coluna.label }}
                                        </div>
                                    </div>
                                    <!-- Conjunto linha coluna -->
                                    <div class="flex-cell" v-for="linha in situacoes">
                                        <b-checkbox 
                                            :id="linha.id +'-'+ coluna.id +'-'+coluna.idServer+'-'+linha.idServer"
                                            @input="selectSituacao($event, linha, coluna)"
                                            :disabled="linha.id == coluna.id"
                                            :value="situacoes.length == situacaoList.length && (situacaoList[linha.id][coluna.id] || (linha.id == coluna.id))">
                                        </b-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import fSwitch from '@/components/shared/form/Switch.vue';

export default {
    components: {
        ContainerLoader,
        fSwitch
    },
    data() {
        return {
            rotaAninhada: false,
            situacoes: [],
            situacaoList:[],
            perfisList:[],
            perfilSelected:null,
            isLoading: false,
            isCheckFilterGrid: false,
            saveChecksList: []
        };
    },
    created() {
        this.carregarDados();
    },
    methods: {
        async carregarDados() {
            const permPerfilAcesso = await this.buscarPerfis();
            this.perfisList = this.mapPerfis(permPerfilAcesso.content);
        },
        async montarGrid(){
            try{
                this.isLoading = true;
                if(!this.perfilSelected){
                    return;
                }

                let associativa = await this.findAssVenPedidoSituacaoPermPerfilAcessoByIdPerfilAcesso(this.perfilSelected.id);
                associativa = associativa && associativa.content ? associativa.content : [];

                const venPedidoSituacaoList = await this.findByIdPerfilAcesso(this.perfilSelected.id);

                this.situacoes = this.filtrarSituacoes(venPedidoSituacaoList.content, associativa);
                this.situacaoList = this.montarMatrizPlotaChecksNaTela(associativa);
            } finally {
                this.isLoading = false;
            }
        },
        async save(){
            if(this.saveChecksList && this.saveChecksList.length > 0){
                await this.persist(this.saveChecksList);
                this.saveChecksList = [];
                this.$root.showMessage('success', 'grid-salvo-sucesso');
            }
        },
        selectPerfil(value){
            if(!this.saveChecksList || (this.saveChecksList && this.saveChecksList.length == 0)){
                this.saveChecksList = [];
                this.situacaoList = [];
                this.perfilSelected = value;
                this.montarGrid();
                return;
            }

            this.$root.confirm({
                message: this.$t("msg-alteracao-perdida"),
                    onConfirm: (_) => {
                        this.saveChecksList = [];
                        this.situacaoList = [];
                        this.perfilSelected = value;
                        this.montarGrid();
                    },
            });
        },
        handleCheckboxClick(value) {
            if(!this.saveChecksList || (this.saveChecksList && this.saveChecksList.length == 0)){
                this.saveChecksList = [];
                this.situacaoList = [];
                this.isCheckFilterGrid = value;
                this.montarGrid();
                return;
            }

            this.$root.confirm({
                message: this.$t("msg-alteracao-perdida"),
                    onConfirm: (_) => {
                        this.saveChecksList = [];
                        this.situacaoList = [];
                        this.isCheckFilterGrid = !this.isCheckFilterGrid;
                        this.montarGrid();
                    }
            });
        },
        mapPerfis(permPerfilAcesso){
            return permPerfilAcesso
                ? permPerfilAcesso.map((item)=>{
                    return {
                        id: item.idperfilacesso,
                        label: item.nome
                    }
                }): [];
        },
        filtrarSituacoes(venPedidoSituacaoList, associativa){
                if(!this.isCheckFilterGrid){
                    return this.mapSituacoesLabel(venPedidoSituacaoList)
                }

                const tmpList = venPedidoSituacaoList.filter(item=>{
                    return associativa.find(ass=>item.id == ass.newIdVenPedidoSituacao || item.id == ass.idVenPedidoSituacao)
                });

                return this.mapSituacoesLabel(tmpList);
        },
        mapSituacoesLabel(venPedidoSituacaoList){
            return venPedidoSituacaoList
                ? venPedidoSituacaoList.map((item,i)=>{
                    return {
                        id: i,
                        label: item.descricao,
                        idServer: item.id
                    }
                }): [];
            },
        montarMatrizPlotaChecksNaTela(associativa){
            return this.situacoes.map(linha => {
                const assSituacao = associativa.filter(ass=> linha.idServer == ass.idVenPedidoSituacao);
                return this.situacoes.map(coluna=>{
                    return !!(assSituacao && assSituacao.find(ass=> ass.newIdVenPedidoSituacao == coluna.idServer))
                })
            });
        },
        selectSituacao(value, linha, coluna) {
            const obj = {
                idVenPedidoSituacao: linha.idServer,
                idPerfilAcesso: this.perfilSelected.id,
                newIdVenPedidoSituacao: coluna.idServer,
                status: value
            }

            const itemExistente = this.saveChecksList.find(check =>
                check.idVenPedidoSituacao == obj.idVenPedidoSituacao
                && check.idPerfilAcesso == obj.idPerfilAcesso
                && check.newIdVenPedidoSituacao == obj.newIdVenPedidoSituacao
            );

            if(itemExistente){
                itemExistente.status = value;
                return;
            }

            this.saveChecksList.push(obj);
        },
        persist(obj){
            return this.$axios.post(`/venpedidosituacao/assvenpedidosituacaopermperfilacesso.json`, obj)
                .then(res => {
                        return res.data;
                    }).catch((e) => {
                        this.$root.showMessage('error', 'msg-erro-load');
                        console.error('Erro ao salvar', e);
                    });
        },
        buscarPerfis(){
            return this.$axios.get(`/config/access-profile-combo.json`)
                .then(res => {
                    return res.data;
                }).catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                });
        },
        findByIdPerfilAcesso(id) {
            return this.$axios.get(`venpedidosituacao/${id}.json`)
                .then(res => {
                    return res.data;
                }).catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                });
        },
        findAssVenPedidoSituacaoPermPerfilAcessoByIdPerfilAcesso(id) {
            return this.$axios.get(`venpedidosituacao/assvenpedidosituacaopermperfilacesso/${id}.json`)
                .then(res => {
                    return res.data;
                }).catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                });
        }
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }

    .field.has-addons {
        display: -webkit-box !important;
    }

    .complete-size{
        height: 100px;
        width: 300px;
        display: flex;
        align-items: center;
    }

    .content-overflow {
        min-height: 100px;
        overflow-x: auto;
        white-space: nowrap;
        background-color: #f9f9f9;
        padding: 5px;
        border-radius: 6px;

        .flex-table {
            display: flex;
            min-width: min-content;

            // .flex-col {}

            .flex-cell {
                background-color: #fff;
                padding: 5px 10px;
                border: solid 1px silver;
                margin: 4px;
                position: relative;
                min-height: 40px;
                min-width: 150px;
                border-radius: 5px;

                .flex-cell-text {
                    display: inline-block;
                    vertical-align: middle;
                }

                .flex-action-box {
                    background-color: rgba(0, 0, 0, 0.7);
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    opacity: 0;
                    display: flex;
                    // justify-content: space-between;
                    justify-content: center;
                    align-items: center;
                    padding: 0 4px;

                    &:hover {
                        opacity: 1;
                    }

                    .flex-action {
                        opacity: 0.6;

                        &:hover {
                            opacity: 1;
                        }
                    }
                }
            }

            .flex-cell-new {
                background-color: #bfdaba;
            }

            .flex-cell-new-intersection {
                background-color: #dfe9dd;
            }

            .flex-cell-deleted {
                background-color: #e4aeae;
            }

            .flex-cell-deleted-intersection {
                background-color: #eccece;
            }
        }
    }
}
</style>
